var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("路线轨迹图")]),_c('div',{staticStyle:{"width":"700px","height":"500px"}},[_c('FmEchartsMap',{ref:"way-lines-map"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }